import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';
import TimerPill from './TimerPill';

import styles from '../../../styles/partials/game-banner.module.scss';

const propTypes = {
    game: AppPropTypes.game.isRequired,
    endAt: PropTypes.string,
    ended: PropTypes.bool,
    onEnded: PropTypes.func,
    question: PropTypes.shape({}),
    participations: PropTypes.number,
    count: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    question: null,
    endAt: null,
    ended: false,
    onEnded: null,
    participations: null,
    count: null,
    className: null,
};

function GameBanner({ game, endAt, ended, onEnded, question, count, participations, className }) {
    const themeClassName = useThemeClassName(styles);
    const { title = null } = game || {};
    const { shortDescription = null } = question || {};
    const description = shortDescription || count;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [themeClassName]: themeClassName !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.left}>
                    {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
                    {description !== null ? (
                        <div className={styles.shortDescription}>{description}</div>
                    ) : null}
                </div>
                <div className={styles.right}>
                    {endAt !== null ? (
                        <div className={styles.time}>
                            <TimerPill
                                date={endAt}
                                started={!ended}
                                onEnded={onEnded}
                                className={styles.timerPill}
                                timerClassName={styles.timer}
                                showDigitsOnEnded
                            />
                        </div>
                    ) : (
                        <div className={styles.time}>
                            {participations !== null && participations > 0
                                ? `Participants: ${participations}`
                                : null}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

GameBanner.propTypes = propTypes;
GameBanner.defaultProps = defaultProps;

export default GameBanner;
